export default "__VITE_ASSET__R$_aFI93__"